module.exports = __webpack_public_path__ + "static/media/home_small.583db552.png";